
define('text!modules/campaign/templates/chart_select_metric.html',[],function () { return '<select class="select-metric form-input">\n\t{{#metrics}}\n\t<option class="item" value="{{value}}" {{#selected}}selected="selected"{{/selected}} {{#hidden}}style="display:none"{{/hidden}} data-tag="{{abbr}}">{{text}}</option>\n\t{{/metrics}}\n</select>';});

